(function () {
  const App = {
    currentLang: document.querySelector('html').getAttribute('xml:lang') ? document.querySelector('html').getAttribute('xml:lang') : document.querySelector('html').getAttribute('lang'),
    thanksPage: {
      es: '640_TP',
      ca: '641_TP'
    },
    errorPage: {
      es: '640_ER',
      ca: '641_ER'
    },
    onReady: function () {
      document.querySelector("bs-eloqua-form").addEventListener("tealiumDataEmitter", function (e) {
        if (e.detail.state === "success") {
          tealium_data.pagina.idPagina = App.thanksPage[App.currentLang];
          tealium_data.prod.paso = "solicitud enviada";
          tealium_data.user.sessionId = e.detail.formData.id_cita;
          bsSend('view', tealium_data);
        } else if (e.detail.state === "error") {
          tealium_data.prod.paso = "error";
          tealium_data.user.sessionId = e.detail.formData.id_cita;
          bsSend('view', tealium_data);
        }
      })
    }
  };
  window.onload = function () {
    App.onReady();
    $(".owl-carousel").owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      responsive: {
        0: {
          items: 1
        }
      }
    })
  }
})();
